import { ca } from '@cian/analytics';

export function trackBannerShow(): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'BlackFriday',
    label: 'landing_banner',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackBannerClick(): void {
  ca('eventSite', {
    action: 'click',
    category: 'BlackFriday',
    label: 'landing_banner',
    name: 'oldevent',
    useLastProducts: true,
  });
}
